/**
 *  AOE
 *
 *  Created by Legman on 25/04/2017.
 *
 */

/**
 * @class
 * @extends PIXI.Container
 */
export default class AOE extends PIXI.Container  {
    /**
     * @param owner
     */
    constructor(owner) {
        super();

        /**
         * @member {number}
         */
        this.duration = 8;

        /**
         * @member {number}
         */
        this.range = 4;

        /**
         * @member {number}
         */
        this.slow = 0.998;

        /**
         * @member {number}
         */
        this.swerve = 0.64;

        /**
         * @member {RaceEntity}
         * @private
         */
        this._owner = owner;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._view = null;
    }

    /**
     */
    init() {
        this._view = new PIXI.Graphics();
        this._view.beginFill(0x0000FF, 0.2);
        this._view.drawCircle(0, 0, 340);
        this._view.endFill();
        this.addChild(this._view);

        TweenMax.to(this.scale, 0.6, {
            x: 0.8,
            y: 0.8,
            ease: Power1.easeInOut,
            yoyo: true,
            repeat: -1
        });
    }

    /**
     * @param {number} dt
     */
    update(dt) {
        // override
    }

    destroy() {
        super.destroy({removeChildren: true});
    }

    /**
     * @returns {RaceEntity}
     */
    get owner() {
        return this._owner;
    }
}